import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Ruler, LogOut } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FDFDFD]">
      <header className="border-b border-zinc-200 bg-white sticky top-0 z-40">
        <div className="px-6 md:px-8 h-14 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/" data-testid="nav-brand" className="flex items-center gap-2">
              <div className="w-7 h-7 bg-[#002FA7] flex items-center justify-center rounded-sm">
                <Ruler size={14} className="text-white" strokeWidth={1.5} />
              </div>
              <span className="font-heading text-sm font-semibold tracking-tight">SCOPEWORKS</span>
            </Link>
            <Link to="/" data-testid="nav-pipeline" className="text-sm text-zinc-600 hover:text-[#002FA7]">Pipeline</Link>
            {user?.role === "admin" && (
              <Link to="/admin" data-testid="nav-admin" className="text-sm text-zinc-600 hover:text-[#002FA7]">Admin</Link>
            )}
          </div>
          <div className="flex items-center gap-4">
            <span data-testid="nav-user-email" className="text-xs text-zinc-500 font-mono">{user?.email}</span>
            <button data-testid="logout-button" onClick={() => { logout(); navigate("/login"); }}
              className="flex items-center gap-1.5 text-xs text-zinc-600 hover:text-red-600 border border-zinc-300 rounded-sm px-2.5 py-1.5 hover:bg-zinc-50">
              <LogOut size={13} strokeWidth={1.5} /> Sign out
            </button>
          </div>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
